var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeftExpand({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4348 18.7344C8.29109 15.6096 4.14771 12.4841 0.00124632 9.36274C0.816016 8.73673 1.64525 8.12864 2.46278 7.50603C5.78678 5.00477 9.10832 2.50041 12.4326 -0.000542232C12.4449 2.0805 12.4348 4.16185 12.4379 6.24289C14.5157 6.24319 16.5936 6.24319 18.6711 6.24319C18.6717 8.32423 18.6726 10.4053 18.6708 12.486C16.5932 12.4863 14.5154 12.486 12.4379 12.4863C12.436 14.5689 12.4425 16.6518 12.4348 18.7344Z",
    fill: "#919191"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftExpand);
export default __webpack_public_path__ + "static/media/left-expand.240e945d889e2fbfc96bc89b1149c03c.svg";
export { ForwardRef as ReactComponent };